import { Paginator } from "primereact/paginator";
import { parse, stringify } from "query-string";
import { useState } from "react";
import { useHistory } from "react-router-dom";

import DownloadDetail from "../../images/download_detail_white.svg";
import { dateToRegularFormat } from "../../utils/dates";
import { ITEMS_PER_PAGE } from "../../utils/valueStaticConstants";
import { GrayDiv } from "../AdminAppointmentConfiguration/AdminAppointmentConfigurationStyled";
import AdminComplaintsDetailSidebar, {
  MainButtonReclamos,
} from "../AdminComplaintsDetailSidebar/AdminComplaintsDetailSidebar";
import { SubtitleDiv } from "../AdminDocumentManagement/AdminDocumentManagementSharedStyles";
import { InvoicesContainer } from "../AdminPaymentValidationTable/CommonTable";
import { Row } from "../DocumentManagement/DocumentManagementSharedStyles";
import { TableHeader } from "../Invoices/InvoicesStyles";
import PaymentLoader from "../PaymentLoader/PaymentLoader";
import StandaloneMessage from "../StandaloneMessage/StandaloneMessage";
import StatusTag from "../StatusTag/StatusTag";
import {
  DivFlexButton,
  DivFlexComplaint,
  FlexJustifyBetween,
} from "./AdminComplaintsTableStyles";
import { DownloadReportModal } from "./DownloadReportModal";
import { ComplaintDoc } from "../AdminComplaints/types";

export const AdminComplaintsTable = ({
  loadComplaints,
}: {
  loadComplaints: any;
}) => {
  const [showModal, updateShowModal] = useState(false);
  const history = useHistory();

  const toggleModal = () => {
    updateShowModal(!showModal);
  };

  const gridTemplateColumns = "repeat(6, 1fr)";

  const [modalReclamos, setModalReclamos] = useState(false);
  const handleClose = () => setModalReclamos(!modalReclamos);
  const [selectedComplaint, updateSelectedComplaint] =
    useState<ComplaintDoc | null>(null);
  const handleClick = (elem) => {
    updateSelectedComplaint(elem);
    updateShowModal(true);
  };
  return (
    <div>
      {loadComplaints.isError && (
        <div>
          Algo salió mal
          <button
            type="button"
            onClick={() => {
              loadComplaints.retry();
            }}
          >
            Reintentar
          </button>
        </div>
      )}
      {loadComplaints.isSuccess && loadComplaints.data.docs.length === 0 && (
        <StandaloneMessage>No hay resultados que mostrar</StandaloneMessage>
      )}
      {loadComplaints.status === "PROCESSING" && (
        <>
          <PaymentLoader numItems={ITEMS_PER_PAGE} />
        </>
      )}
      <div>
        <>
          <InvoicesContainer gridTemplateColumns={gridTemplateColumns}>
            {loadComplaints.isSuccess && loadComplaints.data.docs.length > 0 && (
              <TableHeader className="item-container">
                <div
                  className="left-aligned-header"
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    marginLeft: "2rem",
                  }}
                >
                  NÚMERO / CLIENTE / FECHA DE INGRESO
                </div>
                <div>ÁREA</div>
                <div>PROCESO</div>
                <div>MOTIVO</div>
                <div>ESTADO</div>
                <div>FECHA MÁXIMA</div>
              </TableHeader>
            )}
            {loadComplaints.isSuccess &&
              loadComplaints.data.docs.map((elem: ComplaintDoc) => {
                return (
                  <Row
                    className="item-container"
                    key={elem.complaintId}
                    onClick={() => handleClick(elem)}
                  >
                    <div className="attribute" style={{ display: "contents" }}>
                      <div className="titles">
                        NÚMERO / CLIENTE / FECHA DE INGRESO
                      </div>
                      <div>
                        <SubtitleDiv>{elem.complaintId}</SubtitleDiv>
                        <div>{elem.client.name}</div>
                        <GrayDiv>
                          {dateToRegularFormat(elem.registerDate.split("T")[0])}
                        </GrayDiv>
                      </div>
                    </div>

                    <div className="attribute">
                      <div className="titles">ÁREA</div>
                      <div>{elem.area}</div>
                    </div>
                    <div className="attribute">
                      <div className="titles">PROCESO</div>
                      <div>{elem.process}</div>
                    </div>
                    <div className="attribute">
                      <div className="titles">MOTIVO</div>
                      <div>{elem.reason}</div>
                    </div>
                    <div className="attribute">
                      <div className="titles">ESTADO</div>
                      <div>
                        <StatusTag status={elem.status} />
                      </div>
                    </div>
                    <div className="attribute">
                      <div className="titles">FECHA MÁXIMA</div>
                      <div>
                        {elem.maxDate === null
                          ? "-"
                          : dateToRegularFormat(elem.maxDate.split("T")[0])}
                      </div>
                    </div>
                  </Row>
                );
              })}
          </InvoicesContainer>
          {loadComplaints.status === "SUCCESS" && (
            <>
              {loadComplaints.data.count > 0 && (
                <div className="flex-paginator">
                  <Paginator
                    first={
                      (loadComplaints.params.page - 1) *
                      loadComplaints.data.totalPages
                    }
                    rows={loadComplaints.data.totalPages}
                    totalRecords={loadComplaints.data.count}
                    onPageChange={(e) => {
                      const targetPage =
                        e.first / loadComplaints.data.totalPages;
                      const pathname = history.location.pathname;
                      const parsedParams = parse(history.location.search);
                      const stringifiedParams = stringify({
                        ...parsedParams,
                        page: targetPage + 1,
                      });
                      history.push(`${pathname}?${stringifiedParams}`);
                    }}
                  />
                </div>
              )}
            </>
          )}
          <FlexJustifyBetween>
            {loadComplaints.status === "SUCCESS" && (
              <>
                <DivFlexComplaint>
                  {loadComplaints.data.totalCount > 0 && (
                    <>
                      <div className="flex-paginator">
                        <Paginator
                          first={
                            (loadComplaints.params.page - 1) *
                            loadComplaints.data.limit
                          }
                          rows={loadComplaints.data.limit}
                          totalRecords={loadComplaints.data.totalCount}
                          onPageChange={(e) => {
                            const targetPage =
                              e.first / loadComplaints.data.limit;
                            const pathname = history.location.pathname;
                            const parsedParams = parse(history.location.search);
                            const stringifiedParams = stringify({
                              ...parsedParams,
                              page: targetPage + 1,
                            });
                            history.push(`${pathname}?${stringifiedParams}`);
                          }}
                        />
                      </div>
                      <DivFlexButton>
                        <MainButtonReclamos
                          className="buttom-download"
                          onClick={() => {
                            setModalReclamos(true);
                          }}
                        >
                          <div className="flex-item-center">
                            <div style={{ marginRight: 12 }}>Descargar Q/R</div>
                            <img src={DownloadDetail} alt="downloadDetail" />
                          </div>
                        </MainButtonReclamos>
                        <MainButtonReclamos
                          className="buttom-claim-register"
                          onClick={() =>
                            history.push("/web/admin/registro-quejas-reclamos")
                          }
                        >
                          Registro Queja/Reclamo
                        </MainButtonReclamos>
                      </DivFlexButton>
                    </>
                  )}
                </DivFlexComplaint>
              </>
            )}
          </FlexJustifyBetween>
        </>
      </div>
      {showModal && (
        <AdminComplaintsDetailSidebar
          hideSidebar={toggleModal}
          complaint={selectedComplaint}
          refreshPage={() => {
            loadComplaints.retry();
          }}
        />
      )}
      {modalReclamos && (
        <DownloadReportModal
          params={loadComplaints.params}
          handleClose={handleClose}
          loadComplains={loadComplaints}
        />
      )}
    </div>
  );
};
